import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';

import { AuthService } from '@core/services';

@Injectable()
export class NoAuthGuard {
  loading = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private appGlobals: AppGlobals
  ) {}

  async canActivate() {
    if (!this.authService.isLoggedIn) {
      return true;
    }

    // logged in so redirect to home page
    this.router.navigate([this.appGlobals.homePath]);
    return false;
  }
}
